<template>
  <div>
    <b-card
      class="light-style"
      footer-tag="footer"
    >
      <custom-loader v-if="loader"/>
      <b-form v-else>
        <b-form-row class="pt-3">
          <b-form-checkbox class="ml-1" v-model="modalData.visible_on_public_site">
            Visible on Public Site
          </b-form-checkbox>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Name*">
            <b-input
              v-model="modalData.name"
              placeholder="Name"
              :class="{
                'is-invalid': $v.modalData.name.$error,
                'is-valid': !$v.modalData.name.$invalid,
              }"
              autocomplete="off"
              data-lpignore="true"
            />
            <b-form-invalid-feedback v-if="!$v.modalData.name.required">
              Name is required.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group class="col" label="Category*">
            <b-check-group
              v-model="modalData.category_ids"
              :options="categoriesListing"
              :class="{'is-invalid': $v.modalData.category_ids.$error, 'is-valid': !$v.modalData.category_ids.$invalid}"
            />
            <b-form-invalid-feedback v-if="!$v.modalData.category_ids.required">
              Category must be selected.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group class="col" label="Is this seminar a parent or child?">
            <b-form-radio v-model="modalData.parent_or_child" name="Parent" value="parent">Parent</b-form-radio>
            <b-form-radio v-model="modalData.parent_or_child" name="Child" value="child">Child</b-form-radio>
            <b-select
              v-if="modalData.parent_or_child === 'child'"
              v-model="modalData.parent_seminar_id"
              :options="modalData.parent_seminars"
            />
          </b-form-group>
        </b-form-row>
        <!-- <b-form-row>
          <b-form-group class="col" label="Description">
            <ckeditor
              id="seminarFormDescription"
              v-model="modalData.description"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Teaser">
            <ckeditor
              id="seminarFormTeaser"
              v-model="modalData.teaser"
            />
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Registrant Information">
            <ckeditor
              id="seminarFormRegistrantInformation"
              v-model="modalData.registrant_information"
            />
          </b-form-group>
        </b-form-row> -->
      </b-form>
      <template #footer>
        <div class="d-flex justify-content-end align-items-center">
          <b-button
            variant="danger"
            :disabled="loader"
            @click="close()"
            class="mr-2"
          >
            <b-spinner v-if="loader" />
            CLOSE
          </b-button>
          <b-button
            variant="success"
            class="submit-btn"
            :disabled="loader"
            type="submit"
            @click="onSubmit($event)"
          >
            <b-spinner v-if="loader" />
            UPDATE
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CustomLoader from '@/components/CommonPages/CustomLoader.vue'

export default {
  name: 'SeminarSettingsModalForm',
  props: ['modalData', 'categoriesListing'],
  components: { CustomLoader },
  data () {
    return {
      loader: false
    }
  },
  methods: {
    async onSubmit(event) {
      this.$v.$touch();
      event.preventDefault();
      if (this.$v.$invalid) {
        this.$toasted.global.error("Please fill out the required fields.");
      } else {
        this.loader = true;
        const formData = new FormData()
        formData.append("visible", this.modalData.visible_on_public_site);
        formData.append("name", this.modalData.name);
        formData.append("parent_or_child", this.modalData.parent_or_child);
        formData.append("parent_seminar_id", this.modalData.parent_seminar_id);
        //formData.append("teaser", this.modalData.teaser);
        //formData.append("description", this.modalData.description);
        //formData.append("registrant_information", this.modalData.registrant_information);
        this.modalData.category_ids.forEach((item) => formData.append('categories[]', item))

        const res = await this.$http.patch(process.env.VUE_APP_API_URL + `/seminars/${this.modalData.id}`,formData)
        if(res === undefined){
          //this.$toasted.global.error('Process has been failed.')
        }else if (res.data.error !== undefined) {
          this.$toasted.global.error(res.data.error)
        } else {
          this.$toasted.global.success('Updated Successfully')
          this.loader = false;
          this.$emit('updateSeminarData', false)
        }
      }
    },
    close() {
      this.$emit('updateSeminarData', true)
    }
  },
  validations: {
    modalData: {
      name: {
        required
      },
      category_ids: {
        required
      }
    }
  }
}
</script>
